import { render, staticRenderFns } from "./ShareholdersRow.vue?vue&type=template&id=33bc2fd7&scoped=true&"
import script from "./ShareholdersRow.vue?vue&type=script&lang=js&"
export * from "./ShareholdersRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc2fd7",
  null
  
)

export default component.exports